var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getCustomComponent(_vm.advanced_option),{tag:"component",attrs:{"id":`question-${_vm.question_index}-group-${_vm.questions_groups_index}-advanced-${_vm.advanced_option}-custom`,"question_index":_vm.question_index,"questions_groups_index":_vm.questions_groups_index}})
}
var staticRenderFns = []

export { render, staticRenderFns }